import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';

import { Environment } from '../../../environment';

import { HealthSummary, HealthYearSummary, SomaticCellCountCow } from '../models/health.model';

@Injectable({
  providedIn: 'root',
})
export class HealthReportService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/herd/secure/report/health';

  getSomaticCellCountAttentions(date: string): Observable<SomaticCellCountCow[]> {
    return this.http.get<SomaticCellCountCow[]>(
      `${this.baseUrl}/somatic-cell-count-attentions?date=${date}`,
    );
  }

  getHealthSummary(date: string): Observable<HealthSummary> {
    return this.http.get<HealthSummary>(`${this.baseUrl}/summary?date=${date}`);
  }

  getHealthYearSummary(date: string): Observable<HealthYearSummary> {
    return this.http.get<HealthYearSummary>(`${this.baseUrl}/yearsummary?date=${date}`);
  }
}
